<template>
  <div>
    <div class="page-head">
      <div>
        <h2>工作台总览</h2>
        <p>查看咨询、订单、待处理事项和业务数据变化。</p>
      </div>
    </div>
    <el-row :gutter="16">
      <el-col v-for="item in metrics" :key="item.label" :span="6">
        <el-card class="metric-card" shadow="never">
          <span>{{ item.label }}</span>
          <strong>{{ item.value }}</strong>
        </el-card>
      </el-col>
    </el-row>
    <el-card class="panel-card" shadow="never">
      <div slot="header">快捷入口</div>
      <el-alert
        title="后台只管理业务数据，不提供小程序装修、底部导航配置或新增付款产品类型。"
        type="info"
        show-icon
        :closable="false"
      />
    </el-card>
  </div>
</template>

<script>
import { listResource } from "../api/resources";

export default {
  name: "Dashboard",
  data() {
    return {
      metrics: [
        { label: "今日咨询", value: 0 },
        { label: "今日订单", value: 0 },
        { label: "待跟进需求", value: 0 },
        { label: "待审核评价", value: 0 }
      ]
    };
  },
  mounted() {
    this.fetchMetrics();
  },
  methods: {
    async fetchMetrics() {
      try {
        const res = await listResource("statistics", { page: 1, pageSize: 10 });
        const items = res.data && res.data.items ? res.data.items : [];
        const wanted = ["今日咨询", "今日订单", "待跟进需求", "待审核评价"];
        this.metrics = wanted.map((label) => {
          const match = items.find((item) => item.name === label);
          return { label, value: match ? match.value : 0 };
        });
      } catch (error) {
        this.$message.error(error.message || "工作台数据加载失败");
      }
    }
  }
};
</script>
